import React from "react";
import Carousel from 'react-bootstrap/Carousel';

import Colombina from "../img/gif colombina.gif"
import Coviello from "../img/gif coviello.gif"
import Pantalone from "../img/gif pantalone.gif"
import Pulcinella from "../img/gif pulcinella.gif"
import Tartaglia from "../img/gif tartaglia.gif"



export default function BootstrapCarousel() {
  return (
    
    <Carousel >
      <Carousel.Item >
        <img
          className="d-block"
          style={{ height: 300, width: 800 }}
          src={Colombina}
          alt="First slide"
        />
      </Carousel.Item>
      <Carousel.Item >
        <img
          className="d-block"
          style={{ height: 300, width: 800 }}
          src={Pulcinella}
          alt="Second slide"
        />
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block"
          style={{ height: 300, width: 800 }}
          src={Coviello}
          alt="Third slide"
        />
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block"
          style={{ height: 300, width: 800 }}
          src={Pantalone}
          alt="Fourth slide"
        />
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block"
          style={{ height: 300, width: 800 }}
          src={Tartaglia}
          alt="Fourth slide"
        />
      </Carousel.Item>
    </Carousel>
    
  );
}

